import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { useNotification } from '@hero/store/hooks';

import { services } from '../../services';

export const useUpdateAutomation = ({ options: { onSuccess, ...options } = {} } = {}) => {
  const queryClient = useQueryClient();
  const { showSuccess } = useNotification();

  return useMutation(({ params: { code }, body }) => services.update(code, body), {
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.useGetAutomationKey, variables.params.code],
        refetchType: 'active'
      });

      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.useGetAutomationProductsKey, variables.params.code]
      });

      if (variables.successMessage)
        showSuccess({
          message: variables.successMessage,
          type: 'toast'
        });

      if (onSuccess) onSuccess(data, variables);
    },
    ...options
  });
};
